import React from "react";

const RTMFilterPanel = ({ filters, setFilters, options }) => {
  const today = new Date().toISOString().split("T")[0];

  const toggle = (key, value) => {
    const current = filters[key] || [];
    const exists = current.includes(value);

    setFilters({
      ...filters,
      [key]: exists
        ? current.filter((v) => v !== value)
        : [...current, value],
    });
  };

  return (
    <div className="rtm-filter-dropdown">
      {/* Date */}
      <div className="filter-group">
        <div className="filter-title">Created Date</div>

        <div className="date-row">
          <span>From</span>
          <input
            type="date"
            max={today}
            value={filters.startDate || ""}
            onChange={(e) =>
              setFilters({ ...filters, startDate: e.target.value })
            }
          />
        </div>

        <div className="date-row">
          <span>To</span>
          <input
           
            type="date"
            min={filters.startDate || undefined}
            max={today}
            value={filters.endDate || ""}
            onChange={(e) =>
              setFilters({ ...filters, endDate: e.target.value })
            }
          />
        </div>
      </div>

      {/* Priority */}
      <div className="filter-group">
        <div className="filter-title">Priority</div>

        <div className="filter-scroll">
          {options.priorities.map((p) => (
            <div
              key={p.id}
              className={`filter-item ${
                filters.priority.includes(p.name) ? "active" : ""
              }`}
              onClick={() => toggle("priority", p.name)}
            >
              <input
                type="checkbox"
                checked={filters.priority.includes(p.name)}
                readOnly
              />
              <span>{p.name}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Labels */}
      <div className="filter-group">
        <div className="filter-title">Labels</div>

        <div className="filter-scroll">
          {options.labels.map((l) => (
            <div
              key={l}
              className={`filter-item ${
                filters.labels.includes(l) ? "active" : ""
              }`}
              onClick={() => toggle("labels", l)}
            >
              <input
                type="checkbox"
                checked={filters.labels.includes(l)}
                readOnly
              />
              <span>{l}</span>
            </div>
          ))}

          {options.labels.length === 0 && (
            <div className="no-data">No labels found</div>
          )}
        </div>
      </div>

      {/* Clear */}
      <div
        className="clear-btn"
        onClick={() =>
          setFilters({
            startDate: "",
            endDate: "",
            priority: [],
            labels: [],
          })
        }
      >
        Clear Filters
      </div>
    </div>
  );
};

export default RTMFilterPanel;